export default __webpack_public_path__ + "static/media/exams.3bfae9e8.svg";